import { HttpError } from "./client";

/**
 * O QUE VALE A PENA REPETIR — e o que só faz barulho.
 *
 * O padrão do vue-query são três repetições para QUALQUER falha, e uma resposta de
 * cliente não muda de ideia: um funil que não existe responde 404 as quatro vezes, um
 * campo inválido responde 422 as quatro vezes, um módulo desligado responde 402 as
 * quatro vezes. O custo é visível dos dois lados — a tela fica "a carregar" alguns
 * segundos antes de poder dizer o que houve, e a consola enche-se do mesmo 404 quatro
 * vezes por abertura. Foi assim que um `?funil=` de outra conta se apresentou: quatro
 * pares de 404 e um quadro vazio sem explicação nenhuma.
 *
 * 5xx, rede e timeout continuam a repetir, e são exatamente os que mudam de ideia.
 *
 * 401 nunca chega aqui: `request` renova a sessão e repete o pedido UMA vez sozinho, e
 * o 401 que sobra é uma sessão acabada — que também não muda de ideia.
 */
export function retryUnlessTheAnswerIsFinal(failures: number, error: unknown): boolean {
	if (error instanceof HttpError) {
		const status = error.status ?? 0;
		if (status >= 400 && status < 500) return false;
	}
	return failures < 2;
}
